import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-eap-application-ext',
  templateUrl: './eap-application-ext.component.html',
  styleUrls: ['./eap-application-ext.component.scss']
})
export class EapApplicationExtComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
